import isEmpty from 'lodash/isEmpty';

import i18n from 'shared/lib/i18n';

import StyledLink from '../../StyledLink';

export const getPropertyName = (entry, buildings, pmcs, type, isNameOnly) => {
  if (!entry.property || isEmpty(buildings) || isEmpty(pmcs)) {
    return i18n.t('common.NR');
  }
  const parentPropertyId = entry.property.parentProperty;
  const propertyId = entry.property.id;
  const propertyName = entry.property.name;
  const { propertyLevel } = entry.property;
  switch (type) {
    case 'pmc': {
      let pmcId = null;
      let pmcName = null;
      if (propertyLevel === 'pmc') {
        pmcId = propertyId;
        pmcName = propertyName;
      }
      if (propertyLevel === 'building') {
        const pmc = pmcs[parentPropertyId];
        pmcId = pmc && pmc.id;
        pmcName = pmc && pmc.name;
      }
      if (propertyLevel === 'unit') {
        const building = buildings[parentPropertyId];
        const parent = building && building.parent;
        pmcId = parent && parent.id;
        pmcName = parent && parent.name;
      }

      if (isNameOnly) return pmcName ?? i18n.t('common.NR');
      return pmcId && pmcName ? (
        <StyledLink to={`/pmc/${pmcId}`}>{pmcName}</StyledLink>
      ) : (
        i18n.t('common.NR')
      );
    }
    case 'building': {
      let buildingId = null;
      let buildingName = null;
      if (propertyLevel === 'building') {
        buildingId = propertyId;
        buildingName = propertyName;
      }
      if (propertyLevel === 'unit') {
        const building = buildings[parentPropertyId];
        buildingId = building && building.id;
        buildingName = building && building.name;
      }

      if (isNameOnly) return buildingName ?? i18n.t('common.NR');
      return buildingId && buildingName ? (
        <StyledLink to={`/building/${buildingId}`}>{buildingName}</StyledLink>
      ) : (
        i18n.t('common.NR')
      );
    }
    case 'unit': {
      let unitId = null;
      let unitName = null;
      const buildingId = parentPropertyId;
      if (propertyLevel === 'unit') {
        unitId = propertyId;
        unitName = propertyName;
      }

      if (isNameOnly) return unitName ?? i18n.t('common.NR');
      return unitId && unitName ? (
        <StyledLink to={`/building/${buildingId}/units/${unitId}`}>
          {unitName}
        </StyledLink>
      ) : (
        i18n.t('common.NR')
      );
    }
    case 'door': {
      const { door } = entry;
      if (!door) return i18n.t('common.NR');
      const doorId = door.id;
      const doorName = door.name;
      let buildingId = null;
      if (propertyLevel === 'building') {
        buildingId = propertyId;
      }
      if (propertyLevel === 'unit') {
        buildingId = parentPropertyId;
      }

      if (isNameOnly) return doorName ?? i18n.t('common.NR');
      return buildingId && doorId && doorName ? (
        <StyledLink to={`/building/${buildingId}/doors/${doorId}`}>
          {doorName}
        </StyledLink>
      ) : (
        i18n.t('common.NR')
      );
    }
    default: {
      return '';
    }
  }
};
